<template>
  <div class="h-scroll-comp">
    <div 
    v-on:mousewheel="convertScrollToVertical($event)"
    v-on:touchstart="onTouchStart($event)"
    v-on:touchmove="onTouchMove($event)"
    v-bind:style="{width: itemWidth*totalItems + 'px', transform: 'translateX(' + (+xPosition - +itemWidth/2) + 'px)'}"
    class="inner-wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h-scroll-comp',
  data () {
    return {
      xPosition: 0,
      lastTouchX: null
    }
  },
  props: {
    active: Boolean,
    itemWidth: Number,
    selectedItem: Number,
    totalItems: Number,
    refreshTrigger: Number
  },
  watch: {
    selectedItem: function (selectedItem) {
      this.moveToItem(selectedItem)
    },
    refreshTrigger: function (refreshTrigger) {
      this.moveToItem(this.selectedItem)
    }
  },
  methods: {
    onClose: function () {
      this.$emit('onClose', null)
    },
    moveToItem: function (itemNumber) {
      let newXPosition = -itemNumber * this.itemWidth
      this.xPosition = newXPosition
    },
    convertScrollToVertical: function (event) {
      let newXPosition = this.xPosition + event.wheelDeltaY
      if (newXPosition >= 0) newXPosition = 0
      else if (newXPosition <= -this.itemWidth * (this.totalItems - 1)) newXPosition = -this.itemWidth * (this.totalItems - 1)
      this.xPosition = newXPosition
    },
    onTouchStart: function (event) {
      this.lastTouchX = event.touches[0].pageX
    },
    onTouchMove: function (event) {
      // !!!! Need to be changed below if condition
      if (!this.active) {
        let currentX = event.touches[0].pageX
        let deltaX = currentX - this.lastTouchX

        let newXPosition = this.xPosition + deltaX
        if (newXPosition >= 0) newXPosition = 0
        else if (newXPosition <= -this.itemWidth * (this.totalItems - 1)) newXPosition = -this.itemWidth * (this.totalItems - 1)
        this.xPosition = newXPosition

        this.lastTouchX = currentX

        event.returnValue = false
        if (event.preventDefault) {
          event.preventDefault()
        }
      }
    }
  }
}
</script>

<style scoped>

.h-scroll-container{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.h-scroll-comp .inner-wrapper{
  position: absolute;
  padding: 0;
  left: 50%;
  bottom: 0;
  transition: transform .1s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// HScrollComp.vue?017e1c01